import { render } from "./MenuSection.vue?vue&type=template&id=4d9c86f6&scoped=true"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"

import "./MenuSection.vue?vue&type=style&index=0&id=4d9c86f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9c86f6"]])

export default __exports__